import React, { Component } from 'react';
import ThemeColors from '../../theme/colors';
import renderHTML from 'react-render-html';

class Card extends Component {

  markSearchTerm(match, searchTerm) {
    const indexOfTerm = match.toUpperCase().search(searchTerm.toUpperCase());
    return (
      <p>
        {match.substring(0, indexOfTerm)}
        <span style={{ background: ThemeColors.searchResultColor }}>
          {match.substring(indexOfTerm, searchTerm.length + indexOfTerm)}
        </span>
        {match.substring(searchTerm.length + indexOfTerm, match.length)}
      </p>);
  }

  markSearchTerms(match, searchTerms) {
    const imageUrl = this.getSource(match);
    if (imageUrl) return this.renderImage(imageUrl);
    const keywords = searchTerms.split(/\s/);
    const pattern = new RegExp(`(${keywords.join('|')})`, 'ig');
    const result = match.replace(pattern, m => `<span style="background:${ThemeColors.searchResultColor};">${m}</span>`);

    return (<p>{renderHTML(result)}</p>);
  }

  getSource(match) {
    try {
      return JSON.parse(match).url;
    } catch (e) {
    }

    return null;
  }

  renderImage(url) {
    return (<img src={url} style={{ maxWidth: '100%', maxHeight: 380 }} />);
  }

  render() {
    return (
      <div className={'col-xs-6 col-sm-6 col-lg-3 col-md4'} onClick={this.props.onClick} style={{ cursor: 'pointer' }}>
        <div style={styles.containerStyle}>

          <div style={styles.tileBackground}>
            <span className="pm-card-title-v2" style={{ ...styles.title }}>{this.props.title}</span>
          </div>
          <div style={{ padding: 10 }}>{this.markSearchTerms(this.props.match, this.props.searchTerm)}</div>
        </div>
      </div>
    );
  }
}

Card.defaultProps = {
  title: '',
};

const styles = {
  title: {
    marginTop: '10px',
    paddingRight: '15px',
    marginBottom: 0,
    bottom: '5px',
    width: '100%',
    hyphens: 'auto',
    WebkitHyphens: 'auto',
    wordWrap: 'break-word',
    textTransform: 'uppercase',
  },
  containerStyle: {
    position: 'relative',
    minHeight: 320,
    margin: 10,
    marginLeft: 0,
    borderBottomColor: '#ddd',
    borderBottomWidth: 1,
    borderRightColor: '#ddd',
    borderRightWidth: 1,
    borderRightStyle: 'solid',
    borderBottomStyle: 'solid',
    boxShadow: '-1px -4px 72px 8px rgba(115,115,115,0.07)',
  },
  tileBackground: {
    backgroundColor: '#fff',
    padding: 10,
  },
};

export default Card;



// WEBPACK FOOTER //
// ./src/app/components/tile/tile-without-image.js